import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import qs from "qs";
import { is, can } from "@/helpers/auth";

Object.defineProperty(String.prototype, "capitalize", {
  value: function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false,
});

const token = store.getters.token;

if (token) {
  axios.defaults.headers.Authorization = `Bearer ${token}`;
}

axios.defaults.paramsSerializer = (params) => {
  return qs.stringify(params);
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    let originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      store.dispatch("logout");

      if (router.currentRoute.name != "auth") {
        router.replace({ name: "auth" });
      }
    }
    return Promise.reject(error);
  }
);

// Here is css libraries
import "normalize.css";
import "./styles/global.sass";

// Here is js libraries
import "./plugins";

// Here is custom components
import "./components/forms";
import BaseLayoutContent from "./layouts/BaseLayoutContent.vue";
import BottomSheet from "./components/BaseBottomSheet.vue";
import SimpleList from "./components/BaseSimpleList.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";
import MaterialIcon from "./components/MaterialIcon.vue";
import EmptyState from "./components/EmptyState.vue";
import ButtonLoading from "./components/ButtonLoading.vue";

Vue.config.productionTip = false;

Vue.component("page-content", BaseLayoutContent);
Vue.component("pulse-loader", PulseLoader);
Vue.component("bottom-sheet", BottomSheet);
Vue.component("simple-list", SimpleList);
Vue.component("bulma-accordion", BulmaAccordion);
Vue.component("bulma-accordion-item", BulmaAccordionItem);
Vue.component("material-icon", MaterialIcon);
Vue.component("empty-state", EmptyState);
Vue.component("button-loading", ButtonLoading);

Vue.mixin({
  data: function () {
    return {
      colorPrimary: "#00BCD4",
      colorSuccess: "#5BD395",
      colorWarning: "#E8BA59",
      colorDanger: "#D35B5B",
      akdEducationList: [
        { value: "-7", text: "SD" },
        { value: "-6", text: "SLTP" },
        { value: "-5", text: "SLTA" },
        { value: "-4", text: "D-1" },
        { value: "-3", text: "D-2" },
        { value: "-2", text: "D-3" },
        { value: "-1", text: "D-4" },
        { value: "1", text: "S1" },
        { value: "2", text: "S2" },
        { value: "3", text: "S3" },
        { value: "-8", text: "Lain-lain" },
      ],
      akdReligionList: [
        { value: "1", text: "Islam" },
        { value: "2", text: "Kristen" },
        { value: "3", text: "Katolik" },
        { value: "4", text: "Hindu" },
        { value: "5", text: "Budha" },
      ],
      educationList: [
        { value: "1", text: "SD" },
        { value: "2", text: "SLTP" },
        { value: "3", text: "SLTA" },
        { value: "4", text: "D-1" },
        { value: "5", text: "D-2" },
        { value: "6", text: "D-3" },
        { value: "7", text: "D-4" },
        { value: "8", text: "S1" },
        { value: "9", text: "S2" },
        { value: "10", text: "S3" },
        { value: "11", text: "Lain-lain" },
      ],
      religionList: [
        { value: "Islam", text: "Islam" },
        { value: "Kristen", text: "Kristen" },
        { value: "Katolik", text: "Katolik" },
        { value: "Hindu", text: "Hindu" },
        { value: "Budha", text: "Budha" },
      ],
      bloodList: [
        { value: "O", text: "O" },
        { value: "A", text: "A" },
        { value: "B", text: "B" },
        { value: "AB", text: "AB" },
      ],
    };
  },
  computed: {
    loggedUser: function () {
      return store.getters.loggedUser;
    },
    apiBaseUrl: function () {
      return store.getters.baseUrl;
    },
  },
  methods: {
    is,
    can,
    demoShowSuccess: function () {
      this.$toasted.success("Data berhasil disimpan.");
    },
    isValidEmail: function (email) {
      var re =
        // eslint-disable-next-line no-useless-escape
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    isEmpty: function (str) {
      return !str || 0 === str.length;
    },
    formatDateForHuman: function (strDate, dayName = false, lang = "id") {
      const dayFormat = dayName ? "dddd, DD" : "DD";
      return moment(strDate).locale(lang).format(`${dayFormat} MMMM YYYY`);
    },
    formatDateToISO: function (date) {
      return LuxonDateTime.fromFormat(date, "yyyy-LL-dd").toISO();
    },
    formatDate: function (date) {
      return LuxonDateTime.fromISO(date).toFormat("yyyy-LL-dd");
    },
    formatDateToIndo: function (date) {
      if (!date || date.length != 10) return date;
      return LuxonDateTime.fromFormat(date, "yyyy-LL-dd").toFormat(
        "dd/LL/yyyy"
      );
    },
    formatDateFromIndo: function (date) {
      if (!date || date.length != 10) return date;
      return LuxonDateTime.fromFormat(date, "dd/LL/yyyy").toFormat(
        "yyyy-LL-dd"
      );
    },
    formatTimeToIndo: function (time) {
      return time.substr(0, 5).replace(":", ".");
    },
    generateEmployeeFullname: function (name, prefix, suffix) {
      let fullname = prefix + " " + name;
      if (suffix) fullname += suffix;
      return fullname.trim();
    },
    getReligionFromAkd: function (akdReligionValue) {
      const akdReligionText = this.akdReligionList.find(
        (item) => item.value == akdReligionValue
      )?.text;
      return this.religionList.find((item) => item.text == akdReligionText);
    },
    getEducationFromAkd: function (akdEducationValue) {
      const akdEducationText = this.akdEducationList.find(
        (item) => item.value == akdEducationValue
      )?.text;
      return this.educationList.find((item) => item.text == akdEducationText);
    },
    getDepartmentFromAkd: function (departmentList, akdDepartmentCode) {
      return departmentList.find(
        (item) =>
          item.alias.toUpperCase() == akdDepartmentCode.toString().toUpperCase()
      );
    },
    capitalize: function (str) {
      return str.replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
        letter.toUpperCase()
      );
    },
    plural(number, noun, suffix = "s") {
      let str = number + " " + noun;
      return number > 1 ? str + suffix : str;
    },
    startPageLoading() {
      store.dispatch("startPageLoading");
    },
    stopPageLoading() {
      store.dispatch("stopPageLoading");
    },
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
